// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-23f53300]{display:none}.cta-container[data-v-23f53300]{border-top:1px solid #dadada;padding:16px}@media(min-width:768px){.cta-container[data-v-23f53300]{padding:16px 32px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
